import TokenResource from "./TokenResource";

export interface IBankIdResource {
	bankIdIframeUrl: string;
	bankIdMobileIframeUrl: string;
}

export default class BankIdResource extends TokenResource
	implements IBankIdResource {
	readonly bankIdIframeUrl = "";
	readonly bankIdMobileIframeUrl = "";

	pk() {
		return this.bankIdIframeUrl;
	}

	static url() {
		return `${this.urlRoot}iframeDetails`;
	}

	static urlRoot = "/api/login/";
}
